import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const updateAutopaySettings = async (customerId: string, paymentProfileId: string | null) => {
  const url = `${API_URL}/api/v2/customer/${customerId}/autopay`;
  const body = {
    payment_profile_id: paymentProfileId === 'not_on_autopay' ? null : paymentProfileId
  };

  return await apiRequest(url, "patch", JSON.stringify(body));
};
